import { Link } from 'gatsby';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { getColorFromCode } from '../../common/constants';
import { Menu, UniversePageCategoryPagesCollection } from '../../generated/contentful-generated-types';
import { useCampaign } from '../../hooks/useCampaign';
import { ImageCompressionCDN, ImageFormatAndCompressionCDN, ImageFormatCDN, getImageCDNUri } from '../../utils/CDN-fetcher';
import { PatchContainer } from '../Algolia/SearchHit';
import { SimplePatch as Patch } from '../SimplePatch';

type CategoryGridProps = {
  contentBoxCollection: UniversePageCategoryPagesCollection;
};

const customCompression: ImageCompressionCDN = 2;
export const CategoryGrid: FunctionComponent<CategoryGridProps> = ({ contentBoxCollection }) => {
  const formatAndCompression: ImageFormatAndCompressionCDN = { format: ImageFormatCDN.jpg, compression: customCompression };
  return (
    <StyledGridWrapper>
      {contentBoxCollection.items
        .filter(contentBox => contentBox?.content?.slug != undefined)
        .map(item => {
          const campaign = useCampaign(item?.linkedFrom?.campaignCollection?.items);
          const categoryImage = item?.thumbnailImage;
          const categoryPage = item?.content as Menu;
          const categoryTitle = item?.thumbnailTitle ?? '';
          return (
            categoryPage &&
            categoryImage?.url && (
              <StyledCard data-testid="universe-category-card" key={categoryPage.slug} to={categoryPage.slug}>
                <StyledCardImage
                  src={getImageCDNUri({
                    url: categoryImage.url,
                    width: 213,
                    height: 150,
                    formatAndCompression
                  })}
                  alt={categoryImage?.title}
                />

                <StyledCardTitle className="card-title">{categoryTitle}</StyledCardTitle>
                <CardDescription>{categoryPage.itemsCollection?.items.map((cat: any) => cat.menuLabel).join(', ')}</CardDescription>
                {campaign?.thumbnailPatch && (
                  <PatchContainer>
                    <Patch patch={campaign?.thumbnailPatch} />
                  </PatchContainer>
                )}
              </StyledCard>
            )
          );
        })}
    </StyledGridWrapper>
  );
};
//height:fit-content
const StyledGridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 24px 24px;
  margin: 0 0px;
  padding: 0;

  @media (max-width: 1024px) {
    padding: 0 4px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 4px;
    grid-gap: 16px 4px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 4px;
  }

  @media (max-width: 320px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 16px;
  }
`;

const StyledCard = styled(Link)`
  display: flex;
  position: relative;
  flex-direction: column;

  transition: all 0.5s;
  height: fit-content;
  &:hover {
    .card-title {
      color: ${getColorFromCode('exa pink', '#FF3D77')};
    }
  }
`;

const StyledCardImage = styled.img`
  width: 100%;
  height: auto;
`;

const StyledCardTitle = styled.h2`
  font-family: 'Styrene Medium';
  color: ${getColorFromCode('exa black', '#323232')};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  flex-shrink: 0;
  padding: 16px 8px;
`;

const CardDescription = styled.p`
  color: #666;
  font-size: 14px;
  max-width: 294px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
